import $ from 'jquery';
import product from '@wc-stripe/product';
import {parsePrice, toCents} from '@wc-stripe/utils';

const observeGrandTotal = () => {
    const el = document.querySelector('.wapf-grand-total');
    if (!el) return;

    new MutationObserver(() => {
        const total = parsePrice(el.textContent);
        if (total !== null) {
            const price = total / product.getQuantity();
            const update = {total, price};
            const lineItem = product.getLineItem();
            if (lineItem) {
                update.lineItems = product.getLineItems().map(item =>
                    item.id === lineItem.id
                        ? {...item, amount: total, amountCents: toCents(total)}
                        : item
                );
            }
            product.update(update);
        }
    }).observe(el, {childList: true, characterData: true, subtree: true});
};

$(() => observeGrandTotal());
